import React, { useContext, useEffect, useState } from 'react'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import AdminSlotCard from './AdminSlotCard'
import AdminSlotPage from './AdminSlotPage'
import { useNavigate, useParams } from 'react-router'
import { get, post } from '../../Common/api'
import dayjs from 'dayjs'
import { useForm } from 'antd/es/form/Form'
import GlobalContext from '../GlobalContext'

export default function AdminSlot () {
  const { id } = useParams()
  const params = new URLSearchParams(location.search)
  const from = params.get('from')
  const [slot, setSlot] = useState()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [form] = useForm()
  const { notificationApi } = useContext(GlobalContext)

  useEffect(() => {
    setLoading(true)
    getSlot()
    setLoading(false)
  }, [])

  const screens = useBreakpoint()

  const getSlot = async () => {
    await get({
      url: `admin/slots/${id}`,
      params: {},
      onSuccess: (json) => { setSlot(json) }
    })
  }

  const cancel = () => {
    setLoading(true)
    post({
      url: `admin/slots/${id}/cancel`,
      params: {},
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (json) => {
        setSlot(json)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const delay = () => {
    setLoading(true)
    post({
      url: `admin/slots/${id}/delay`,
      params: {},
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (json) => {
        setSlot(json)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const back = () => {
    if (from === 'list') {
      navigate(`/admin/slots?day=${dayjs(slot.begin_date).format('YYYY-MM-DD')}`)
    } else if (from === 'calendar') {
      navigate(`/admin/boxes/${slot.box.id}/calendar?day=${dayjs(slot.begin_date).format('YYYY-MM-DD')}`)
    } else {
      navigate('/admin/events')
    }
  }

  return (
    <>
    {!screens.lg && slot && <AdminSlotCard form={form} slot={slot} setSlot={setSlot} loading={loading} setLoading={setLoading} cancel={cancel} back={back} delay={delay} />}
    {screens.lg && slot && <AdminSlotPage form={form} slot={slot} setSlot={setSlot} loading={loading} setLoading={setLoading} cancel={cancel} back={back} delay={delay} />}
    </>
  )
}
